import React from 'react';
import { Box, Typography } from '@mui/material';
import { Timeline, TimelineStepProps, useL2DTheme } from '@europrocurement/flexy-components';

type LifecycleSectionProps = {
    offerName?: string;
};

const LIFECYCLE_STEPS_BASE = [
    'Prospect',
    'Qualifié',
    'Démo réalisée',
    '1er dossier',
    'Client actif',
];
const LIFECYCLE_AMBASSADOR = 'Ambassadeur';
const OFFER_STEP_INDEX = 5;

function buildLifecycleSteps(offerName?: string): TimelineStepProps[] {
    const offerLabel = offerName ?? 'Offre actuelle';
    const allLabels = [...LIFECYCLE_STEPS_BASE, offerLabel, LIFECYCLE_AMBASSADOR];

    return allLabels.map((label, index) => ({
        id: index,
        label,
        current: index === OFFER_STEP_INDEX,
    }));
}

const LifecycleSection: React.FunctionComponent<LifecycleSectionProps> = function ({ offerName }) {
    const { palette } = useL2DTheme();
    const steps = buildLifecycleSteps(offerName);

    return (
        <Box sx={{ flex: 1 }}>
            <Typography
                variant="caption"
                sx={{ fontWeight: 700, textTransform: 'uppercase', color: palette.text.secondary }}
            >
                Cycle de vie du prescripteur
            </Typography>
            <Box sx={{ mt: 2 }}>
                <Timeline steps={steps} />
            </Box>
        </Box>
    );
};

export default LifecycleSection;
